// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3IWI1","title":"Info_title__3c1wA","links":"Info_links__1vqJA","link":"Info_link__3E8YL","logo":"Info_logo__33Oob"};